<template src="./approve.html"></template>

<script>
import axios from 'axios'
import QuotePreview from '../../quote/modals/preview/preview.vue'
import { store } from '../../../store/store'

export default {
  name: 'invoice-approve',
  components: {
    QuotePreview
  },
  data: function () {
    return {
      pageState: 'loading',
      errorMessage: '',
      invoice: {},
      invoiceItems: [],
      contact: {},
      settings: {},
      invoiceNumber: '',
      invoiceTotal: ''
    }
  },
  methods: {
    loadInvoice: function (uuid) {
      this.pageState = 'loading'
      axios.get('public/invoice/' + uuid).then((response) => {
        const payload = response.data || {}
        const invoice = payload.invoice || {}
        const items = Array.isArray(invoice.items) ? invoice.items : []
        this.invoice = Object.assign({}, invoice)
        delete this.invoice.items
        // Customer invoice view must not surface quote option tabs
        delete this.invoice.options
        this.invoiceItems = items
        this.contact = invoice.contact || {}
        this.settings = payload.settings || {}
        this.pageState = 'review'
      }).catch((err) => {
        this.errorMessage = (err.response && err.response.data && err.response.data.error)
          ? err.response.data.error
          : 'Invoice not found'
        this.pageState = 'error'
      })
    },
    onApproved: function (payload) {
      this.invoiceNumber = payload.number || this.invoice.number || ''
      this.invoiceTotal = payload.total != null ? payload.total : this.invoice.total
      this.pageState = 'success'
    }
  },
  mounted: function () {
    store.commit('setFooter', false)
    this.loadInvoice(this.$route.params.uuid)
  },
  beforeUnmount: function () {
    store.commit('setFooter', true)
  }
}
</script>

<style scoped>
.invoice-approve-page {
  min-height: calc(100vh - 48px);
  background: var(--color-very-light-grey);
  padding-top: 48px;
  box-sizing: border-box;
}
#app:has(.integration-expired-banner) .invoice-approve-page {
  padding-top: 32px;
}
.invoice-approve-status {
  max-width: 560px;
  margin: 4rem auto;
  text-align: center;
  padding: 0 1rem;
}
</style>
